import { IApplicationState } from '../../types/redux';

export const getIsReviewDetailsOpen = (state: IApplicationState) => {
  return state.reviewsDetails.isOpen;
};
